// @ts-nocheck
import React, { useState } from 'react';
import cx from 'classnames';
import { cssInJS } from '../../utils/styles';
import { InfoAltIcon } from '../../icons';
import Dialog from '../../shared/dialog';

interface Props {
  description: string;
  label: string;
  className?: string;
}

const DescriptionButton: React.FC<Props> = ({
  description,
  label,
  className,
}: Props) => {
  const [showDescription, setShowDescription] = useState<boolean>(false);

  const classes = css(styles.container,
    !description && styles.hidden);

  const handleButtonClick = (showDescriptionValue: boolean): any => { setShowDescription(showDescriptionValue); };

  return (
    <div
      className={cx(className, classes)}
      title={description}
      onClick={() => handleButtonClick(true)}
    >
      <InfoAltIcon className={css(styles.icon)} />
      <Dialog
        negative={null}
        show={showDescription}
        title={label}
        onPositiveClick={() => handleButtonClick(false)}
      >
        <div>{description}</div>
      </Dialog>
    </div>
  );
};

const styles = cssInJS({
  container: {
    alignItems: 'center',
    backgroundColor: '#fff',
    color: '#aaa',
    cursor: 'pointer',
    display: 'flex',
    fill: '#ccc',
    justifyContent: 'center',
    paddingRight: '0.5rem',
    visibility: 'visible',
    width: '3%',

    ':hover': {
      fill: '#444',
    },

    '@phone': {
      display: 'block',
      position: 'absolute',
      right: 32,
      top: 0,
      width: 16,
      height: 16,
      zIndex: 10,
    },
  },

  hidden: {
    display: 'none',
  },

  icon: {
    display: 'inline-block',
    width: 16,
    height: 16,
  },
});

export default DescriptionButton;
